<div
  [cbPopover]="Calendar"
  [showArrow]="false"
  (popoverClose)="resetPopover(); onTouchedCallback()"
  [matchParentWidth]="false"
  class="cb-datepicker-wrapper"
  [class.cb-disabled]="disabled()"
  [class.cb-required]="required()"
  [class.cb-error]="error()"
>
  @if (label() || info()) {
    <div class="cb-datepicker-label">
      @if (label()) {
        <label>{{ label() }}</label>
      }
      @if (info() && info()!.length > 0) {
        <cb-icon
          [cbTooltip]="info()!"
          tooltipPosition="top"
          tooltipStyle="dark"
          name="cb-base-outline-help"
        ></cb-icon>
      }
    </div>
  }
  <div class="cb-datepicker-container">
    <div class="cb-datepicker" [class.cb-reset]="canReset">
      @if (icon()) {
        <div #Prefix class="cb-datepicker-prefix">
          @if (icon()) {
            <cb-icon [name]="icon()"></cb-icon>
          }
        </div>
      }

      <div
        class="cb-datepicker-value"
        [attr.tabindex]="disabled() ? undefined : 0"
      >
        @if (value.length > 0) {
          <span>{{ strValue }}</span>
        } @else {
          <span class="cb-datepicker-placeholder">{{ placeholder() }}</span>
        }
      </div>

      @if (canReset) {
        <div
          class="cb-datepicker-reset-button-container"
          (click)="reset(); $event.stopImmediatePropagation()"
        >
          <div class="cb-datepicker-reset-button">
            <cb-icon name="cb-base-outline-close"></cb-icon>
          </div>
        </div>
      }
    </div>
  </div>
  @if (hint() && hint()!.length > 0) {
    <p class="cb-datepicker-hint">{{ hint()! }}</p>
  }
</div>

<ng-template #Calendar>
  <div class="cb-calendar-container">
    @if (selectionMode() === "range" && shortcuts()) {
      <div class="cb-calendar-sidebar">
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('this_week')"
        >
          <p>{{ "COMMON.DATEPICKER.THIS_WEEK" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('last_7_days')"
        >
          <p>{{ "COMMON.DATEPICKER.LAST_7_DAYS" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('this_month')"
        >
          <p>{{ "COMMON.DATEPICKER.THIS_MONTH" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('last_30_days')"
        >
          <p>{{ "COMMON.DATEPICKER.LAST_30_DAYS" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('last_3_months')"
        >
          <p>{{ "COMMON.DATEPICKER.LAST_3_MONTHS" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('last_6_months')"
        >
          <p>{{ "COMMON.DATEPICKER.LAST_6_MONTHS" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('this_year')"
        >
          <p>{{ "COMMON.DATEPICKER.THIS_YEAR" | translate }}</p>
        </div>
        <div
          class="cb-calendar-sidebar-option"
          (click)="periodShortcutSelected('last_12_months')"
        >
          <p>{{ "COMMON.DATEPICKER.LAST_12_MONTHS" | translate }}</p>
        </div>
      </div>
    }
    <div class="cb-calendar" [ngClass]="'cb-type-' + currentSelectionType()">
      <div class="cb-calendar-selectors">
        <div (click)="previous()" class="cb-calendar-arrow">
          <cb-icon name="cb-base-outline-chevron-left"></cb-icon>
        </div>
        @switch (currentSelectionType()) {
          @case ("day") {
            <div
              class="cb-calendar-period-selector"
              (click)="previousSelectionType()"
            >
              <h6>
                {{ months[currentMonth()] | translate }} {{ currentYear() }}
              </h6>
            </div>
          }
          @case ("month") {
            <div
              class="cb-calendar-period-selector"
              (click)="previousSelectionType()"
            >
              <h6>{{ currentYear() }}</h6>
            </div>
          }
          @case ("year") {
            <div class="cb-calendar-period-selector cb-disabled">
              <h6>
                {{ yearsRangeOptions[0] }} -
                {{ yearsRangeOptions[yearsRangeOptions.length - 1] }}
              </h6>
            </div>
          }
        }
        <div (click)="next()" class="cb-calendar-arrow">
          <cb-icon name="cb-base-outline-chevron-right"></cb-icon>
        </div>
      </div>

      @switch (currentSelectionType()) {
        @case ("day") {
          <div class="cb-calendar-days">
            <div class="cb-calendar-weekdays">
              <p>{{ "COMMON.MONDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.TUESDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.WEDNESDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.THURSDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.FRIDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.SATURDAY" | translate | slice: 0 : 1 }}</p>
              <p>{{ "COMMON.SUNDAY" | translate | slice: 0 : 1 }}</p>
            </div>
            <div class="cb-calendar-days-grid">
              @for (d of calendarGrid(); track $index) {
                <div
                  class="cb-calendar-day"
                  [class.cb-other-month]="!d.isCurrentMonth"
                  [class.cb-selected]="d.day.isSelected"
                  [class.cb-disabled]="d.day.isDisabled"
                  [class.cb-today]="d.day.isToday"
                  (click)="daySelected(d.day)"
                >
                  <p>{{ d.day.date | date: "d" }}</p>

                  <div class="cb-calendar-events">
                    @for (e of d.day.events | slice: 0 : 3; track $index) {
                      <div
                        class="cb-calendar-event"
                        [ngClass]="'cb-' + e.color"
                      ></div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @case ("month") {
          <div class="cb-calendar-months">
            @for (m of calendarGrid(); track $index) {
              <div
                class="cb-calendar-month"
                [class.cb-selected]="
                  selectedDates().length > 0 &&
                  isSameMonth(m.day.date, selectedDates()[0])
                "
                [class.cb-today]="m.day.isToday"
                [class.cb-selected]="m.day.isSelected"
                (click)="monthSelected(m.day)"
              >
                <p>{{ m.day.date | date: "MMMM" }}</p>
              </div>
            }
          </div>
        }
        @case ("year") {
          <div class="cb-calendar-years">
            @for (y of yearsRangeOptions; track $index) {
              <div class="cb-calendar-year" (click)="yearSelected(y)">
                <p>{{ y }}</p>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</ng-template>
